'use strict';

import React, { useState, useEffect } from "react";
import { useCart, useCartDispatch } from "../../../../common/CartContext";
import { publish } from "../../../../common/EventDispatcher";

function ButtonAddToCart({ nsProductId, nid, icon, name, unitPrice }) {
  const [inCart, setInCart] = useState(false);
  const dispatch = useCartDispatch();
  const cartContents = useCart();

  useEffect(() => {
    const cartItem = cartContents.find((item) => item.nid === nid);
    if (cartItem) {
      setInCart(true);
    } else {
      setInCart(false);
    }
  }, [cartContents]);

  function handleAddToCart() {
    if (inCart) {
      dispatch({
        type: "REMOVE_FROM_CART",
        nid: nid
      });
    } else {
      dispatch({
        type: "ADD_TO_CART",
        nsProductId: nsProductId,
        nid: nid,
        icon: icon,
        name: name,
        unitPrice: unitPrice,
        quantity: 1
      });
      publish("productAddedToCart");
    }
  }

  return (
    <div className="d-flex add-button" data-cart-status={inCart}>
      <button className="primary-button" onClick={handleAddToCart} type="button">
        {inCart ? "Remove from Cart" : "Add to Cart"}
      </button>
    </div>
  );
}

export default ButtonAddToCart;
